export const imaginePayActions = [
  { name: 'registerImaginePayCard', label: 'Register Card', args: [] },
];
